/**
 * Onglet Gestion d'équipe - Prestataire Libre
 * Design identique à l'Accord Cadre (PJ1) :
 * - Section 1 : Membres de l'équipe (GestionComptesPrestataires)
 * - Section 2 : Affectation des membres sur les lots (GestionComptes)
 */
import React from 'react';
import GestionComptesPrestataires from '../../../composants/GestionComptesPrestataires/GestionComptesPrestataires';
import GestionComptes from '../../../composants/GestionComptes/GestionComptes';
import './TabEquipe.css';

const TabEquipe: React.FC = () => {
  return (
    <div className="tab-equipe">
      {/* Section 1 : Membres de l'équipe */}
      <div className="equipe-section">
        <div className="section-header">
          <h2>Membres de l'équipe</h2>
        </div>
        <div className="section-content">
          <GestionComptesPrestataires />
        </div>
      </div>

      {/* Section 2 : Affectation des membres sur les lots */}
      <div className="equipe-section">
        <div className="section-header">
          <h2>Affectation des membres sur les lots</h2>
        </div>
        <div className="section-content">
          <GestionComptes />
        </div>
      </div>
    </div>
  );
};

export default TabEquipe;
